import { render, staticRenderFns } from "./manageNotification.vue?vue&type=template&id=dec61ff4&"
import script from "./manageNotification.vue?vue&type=script&lang=js&"
export * from "./manageNotification.vue?vue&type=script&lang=js&"
import style0 from "./manageNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports